import React, { Dispatch, SetStateAction } from 'react'
import { AuthChoiceType } from '../pages/Auth/Signup';

interface AuthChoiceProps {
  authChoice :  AuthChoiceType;
  setAuthChoice: Dispatch<SetStateAction<AuthChoiceType>>;
}

const AuthChoice: React.FC<AuthChoiceProps> =({
  authChoice,
  setAuthChoice
})=> {
  return (
        <div className='flex justify-around w-full mt-24'>
            <button className='bg-[#A643FE] w-[12.5rem] h-[2.5rem] rounded' onClick={()=>{setAuthChoice("user")}}>User</button>
            {/* <button className='bg-[#A643FE] w-[200px] h-[40px] rounded' onClick={()=>{setAuthChoice("org")}}>Organization</button> */}
        </div>
  )
}

export default AuthChoice